var cookieConsent = function () {
    var popup_wrapper;

    var setCookie = function (name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    var removeCookie = function (name) {
        document.cookie = name + '=; Max-Age=-99999999;';
    }

    var getCookie = function (name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    var handlers = () => {

        // Tümünü kabul et
        $(document).on('click', 'button[data-cookie_accept]', function () {
            $.post('/'+i18n.locale + '/api/v1/cookie-update',{all:true},function (data) {},'json');
            popup_wrapper.fadeOut(300, function () {
                $(this).remove();
            });
        });

        // Ayarları göster
        $(document).on('click', 'button[data-cookie_settings]', function () {
            $.get('/'+i18n.locale + '/api/v1/cookie-settings', function (data) {
                if (data.status === 'error')
                    return;
                $('body').append(data.data);

                $(document).find('.cookie_modal').fadeIn(300);
            },'json');
        });


        $(document).on('click', '.cookie_modal__content__close', function () {
            $(document).find('.cookie_modal').fadeOut(300, function () {
                $(this).remove();
            });
        });

        $(document).on('click', '.cookie_modal__content_approve', function () {
            $.post('/'+i18n.locale + '/api/v1/cookie-update',{all:true},function (data) {},'json');

            $(document).find('.cookie_modal').fadeOut(300, function () {
                $(this).remove();
            });
            popup_wrapper.fadeOut(300, function () {
                $(this).remove();
            });
        });

        $(document).on('click', '[data-cookie-modal-tab]', function () {
            var tab = $(this).data('cookie-modal-tab');
            $(document).find('[data-cookie-modal-tab]').removeClass('active')
            $(document).find('[data-cookie-modal-tabcontent]').removeClass('active')

            $(this).addClass('active')
            $(document).find('[data-cookie-modal-tabcontent="'+tab+'"').addClass('active')
        });

        $(document).on('change', '.cookie_modal__content_tabcontent__slider input', function () {
            if ($(this).is(':checked')) {
                $.post('/'+i18n.locale + '/api/v1/cookie-update',{cookie:$(this).attr('name'), status: true},function (data) {},'json');
            } else {
                $.post('/'+i18n.locale + '/api/v1/cookie-update',{cookie:$(this).attr('name'), status: false},function (data) {},'json');
            }
        });
    }


    var appendPopup = function () {
        var cookie_consent_all = getCookie('cookie_consent_all');
        var cookie_consent = getCookie('cookie_consent');

        if (cookie_consent_all !== null || cookie_consent !== null)
            return false;

        var popup_template = `
        <div class="cookie_pp" style="display: none">
            <div class="cookie_pp__desc">${i18n.General.cookie_popup_text}</div>
            <div class="cookie_pp__actions">
                <button class="cookie_pp__accept" data-cookie_accept="" aria-label="Accept">
        
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M235.3 331.3C229.1 337.6 218.9 337.6 212.7 331.3L148.7 267.3C142.4 261.1 142.4 250.9 148.7 244.7C154.9 238.4 165.1 238.4 171.3 244.7L224 297.4L340.7 180.7C346.9 174.4 357.1 174.4 363.3 180.7C369.6 186.9 369.6 197.1 363.3 203.3L235.3 331.3zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 32C132.3 32 32 132.3 32 256C32 379.7 132.3 480 256 480C379.7 480 480 379.7 480 256C480 132.3 379.7 32 256 32z"/></svg>
                </button>
                <button class="cookie_pp__settings" aria-label="Settings" data-cookie_settings="">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 456.556 456.556"><g><path d="M97.564 79.443H13.428C6.011 79.443 0 73.428 0 66.015s6.011-13.428 13.428-13.428h84.136c7.417 0 13.428 6.015 13.428 13.428s-6.011 13.428-13.428 13.428z" fill="#000000" opacity="1" data-original="#000000" class=""></path><path d="M145.643 127.518c-33.916 0-61.507-27.591-61.507-61.504 0-33.92 27.591-61.511 61.507-61.511s61.507 27.591 61.507 61.511c0 33.914-27.591 61.504-61.507 61.504zm0-96.158c-19.107 0-34.651 15.547-34.651 34.654s15.544 34.647 34.651 34.647 34.651-15.54 34.651-34.647S164.75 31.36 145.643 31.36zM443.128 79.443H242.433c-7.417 0-13.428-6.015-13.428-13.428s6.011-13.428 13.428-13.428h200.694c7.417 0 13.428 6.015 13.428 13.428s-6.01 13.428-13.427 13.428zM325.936 289.782c-33.917 0-61.507-27.591-61.507-61.504s27.591-61.504 61.507-61.504 61.507 27.591 61.507 61.504-27.59 61.504-61.507 61.504zm0-96.151c-19.107 0-34.651 15.54-34.651 34.647s15.544 34.647 34.651 34.647 34.651-15.54 34.651-34.647-15.544-34.647-34.651-34.647zM229.149 241.706H13.428C6.011 241.706 0 235.691 0 228.278s6.011-13.428 13.428-13.428h215.721c7.417 0 13.428 6.015 13.428 13.428s-6.011 13.428-13.428 13.428z" fill="#000000" opacity="1" data-original="#000000" class=""></path><path d="M443.128 241.706h-69.113c-7.417 0-13.428-6.015-13.428-13.428s6.011-13.428 13.428-13.428h69.113c7.417 0 13.428 6.015 13.428 13.428s-6.011 13.428-13.428 13.428zM130.62 452.052c-33.916 0-61.507-27.591-61.507-61.511 0-33.913 27.591-61.504 61.507-61.504s61.507 27.591 61.507 61.504c0 33.92-27.591 61.511-61.507 61.511zm0-96.158c-19.107 0-34.651 15.54-34.651 34.647s15.544 34.654 34.651 34.654 34.651-15.547 34.651-34.654-15.544-34.647-34.651-34.647zM443.128 403.97H227.407c-7.417 0-13.428-6.015-13.428-13.428 0-7.413 6.011-13.428 13.428-13.428h215.721c7.417 0 13.428 6.015 13.428 13.428 0 7.413-6.011 13.428-13.428 13.428z" fill="#000000" opacity="1" data-original="#000000" class=""></path><path d="M82.541 403.97H13.428C6.011 403.97 0 397.955 0 390.541c0-7.413 6.011-13.428 13.428-13.428h69.113c7.417 0 13.428 6.015 13.428 13.428 0 7.414-6.011 13.429-13.428 13.429z" fill="#000000" opacity="1" data-original="#000000" class=""></path></g><</svg>
                </button>
            </div>
        </div>`;
        $('body').append(popup_template);
        return true;
    }

    var appendSettings = function () {

    }


    return {
        init: function () {
            let append = appendPopup();
            if (!append)
                return;

            popup_wrapper = $(document).find('.cookie_pp')
            popup_wrapper.fadeIn(600);

            handlers();
        }
    };
}

$(document).ready(function () {
    setTimeout(() => {
        cookieConsent().init();
    }, 600);
});

